import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BackOfficeStampTransformer  {
    _originalTypeClassName = "zERP.BO.BackOfficeStampTransformer";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackOfficeStampTransformer.translate = translateService;
}
this.BackOfficeStampTransformerKey = null;
this._key = this.BackOfficeStampTransformerKey = 0; 
}

static translate: TranslateService;
_key: any;
private _BackOfficeStampTransformerKey:any;
get BackOfficeStampTransformerKey(): any {
    return this._BackOfficeStampTransformerKey;
  }
set BackOfficeStampTransformerKey(value: any) {
    this._BackOfficeStampTransformerKey = value;
    this._key = value;
  }

static CancellationDocumentToStampDocument(stampCancellation: any): any{let stampDocument;
stampDocument.cancellationDate = stampCancellation.cancellationDate;
stampDocument.cancellationPaymentType = stampCancellation.cancellationPaymentType;
stampDocument.cancellationUser = stampCancellation.cancellationUser;
stampDocument.date = stampCancellation.date;
stampDocument.id = stampCancellation.id;
stampDocument.isCancelled = stampCancellation.isCancelled;
stampDocument.issuerDepartment = stampCancellation.issuerDepartment;
stampDocument.paymentType = stampCancellation.paymentType;
stampDocument.user = stampCancellation.user;
stampDocument.stampDetails = stampCancellation.stampDetails;
return stampDocument;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BackOfficeStampTransformerKey == null || $this.BackOfficeStampTransformerKey == 0;
            }


}